var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"lazy":"","card":""}},[_c('b-tab',{attrs:{"title":"CUSTOMERS LIST"}},[_c('ListCustomers')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"LOCATION ANALYTICS"}},[_c('LocationCustomers')],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f03d5c8e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/CustomerMain.vue
// module id = null
// module chunks = 